export default __webpack_public_path__ + "static/media/TrueSpartan.5b9b7052.png";